import { BrandModel } from "./brand.model";
import { BusinessEntityModel } from "./business-entity.model";
import { InformationModel } from "./information.model";
import { LinkModel } from "./link.model";
import { LocationModel } from "./location.model";
import { OnboardingModel } from "./onboarding.model";
import { PaymentMethodModel } from "./payment-method.model";
import { SettingModel } from "./setting.model";
import { TotemModel } from "./totem.model";



export enum SiteType {
  single = 'single',
  multiple = 'multiple',
  booking = 'booking'
}
class StoreSiteModel {
  id: string;
  name: string;

  constructor(obj: any = null) {
    this.id = obj && obj.id || undefined;
    this.name = obj && obj.name || undefined;
  }
}

export class SiteModel extends BusinessEntityModel {
  type: string;
  stores: string[]
  onboarding: OnboardingModel
  links: LinkModel[]
  locations: LocationModel[]
  totems: TotemModel[]

  constructor(obj: any = null) {
    super(obj)
    this.type = obj?.type
    this.stores = obj?.stores || []
    this.onboarding = new OnboardingModel(obj?.onboarding)
    this.links = obj?.links ? obj?.links.map((i: any) => (new LinkModel(i))) : []
    this.locations = obj?.locations ? obj?.locations.map((i: any) => (new LocationModel(i))) : []
    this.totems = obj?.totems ? obj?.totems.map((i: any) => (new TotemModel(i))) : []
  }
}



